<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { getCustomers } from '../../services/saleApi'
import { CustomerInterface } from '../../models/CustomerModel'
import { PaginatedResult, PaginationMeta } from '../../services/api'
import APagination from '../common/APagination.vue'
import ALoader from '../common/ALoader.vue'

const customers = ref<CustomerInterface[]>([])
const pagination = ref<PaginationMeta | null>(null)
const isLoading = ref<boolean>(true)
const searchInput = ref<string>('')
const searchEl = ref<HTMLInputElement | null>(null)

const emit = defineEmits<{
  customerSelected: CustomerInterface
}>()

function getCustomerResults(page: number, search = ''): void {
  isLoading.value = true
  getCustomers(page, search)
    .then((result: PaginatedResult<CustomerInterface>) => {
      customers.value = result.items
      pagination.value = result.pagination
    })
    .finally(() => {
      isLoading.value = false
    })
}

function changePage(page: number): void {
  getCustomerResults(page, searchInput.value)
}

function onSearchKeyUp(e: KeyboardEvent) {
  if (e.key !== 'Enter' || !searchEl.value) return
  searchEl.value.blur()
}

function onSearchBlur() {
  getCustomerResults(1, searchInput.value)
}

onMounted(() => {
  getCustomerResults(1)
})
</script>

<template>
  <div class="mb-24">
    <div class="mb-12">{{ $t('choose-customer') }}:</div>
    <input
      ref="searchEl"
      v-model="searchInput"
      type="search"
      class="form-control search mb-12"
      :placeholder="$t('search')"
      autocomplete="off"
      spellcheck="false"
      :disabled="isLoading"
      @keyup="onSearchKeyUp"
      @blur="onSearchBlur"
    />
    <ALoader v-if="isLoading" />
    <div v-else>
      <div
        v-for="(customer, customerIndex) in customers"
        :key="customerIndex"
        class="customer-item"
      >
        <button @click="emit('customerSelected', customer)">
          <b>{{ customer.name }}</b>
          <small>{{ customer.code }}</small>
          <span>{{ customer.address }}</span>
        </button>
      </div>
    </div>
    <APagination
      v-if="pagination"
      :pagination="pagination"
      class="mt-24"
      @page-change="changePage"
    />
  </div>
</template>
